import moment from 'moment'


export default {
  routesPermissions: {
    requireAuth: [
      '/admin'
    ],
    routesRequireAdmin: [
      '/admin'
    ]
  },
  routing: {},
  user: {
    isAdmin: undefined
  },
  auth: {
    isLogged: false,
    currentUserUID: null,
    initialized: false
  },
  ajaxCallsInProgress: 0,
  contractInfo: {
    grid: [],
    detailed_grid: [],
    final_grid: [],
    grid_format: [],
    selectedOption: '',
    selected_schedule_type: '',
    tabIndex: 0,
    modeTabIndex: 0,
    block_to_detailed_mapping: [],
    categories_minutes: {
      classroom_teaching: 0,
      middle_classroom: 0,
      high_classroom: 0,
      non_academic: 0,
      break: 0,
      sep_1: 0,
      sep_2: 0,
      sep_3: 0,
      colab: 0,
      pie_middle_classroom:0,
      pie_high_classroom:0,
      non_visible_sep_1: 0,
      yard_turn: 0,
    },
    total_minutes: 0,
    total_minutes_final: 0,
    sep_1_headship_minutes: 0,
    headship: {
      value: 'none'
    },
    old_hours: {
      middle_classroom: 0,
      high_classroom: 0,
      sep_1: 0,
      sep_2: 0,
      sep_3: 0
    },
    overwrited_hours: {
      middle: 0,
      high: 0,
      sep_1: 0,
      sep_2: 0,
      break: 0,
      non_academic:0
    },
    overwrited: {
      middle:false,
      high:false,
      sep_1:false,
      sep_2:false
    },
    startDate: 2018,
    startPeriod: 0,
    contractDate: moment().format('DD-MM-YYYY'),
    proportion_to_use: 'new',
    bonuses: {
      brp_titulo: true,
      brp_mencion: true,
      ley: true,
      ley_pie:true
    },
    sep_2_hour_type: 'weighted',
    sep_2_hour_value_other: 0,
    sep_3_hour_value: 0,
    yard_turn_hour_value: 0,
    pie_middle_classroom_hour_value: 0,
    pie_high_classroom_hour_value: 0,
    signing_date: moment().format('DD-MM-YYYY'),
    id: '',
    saved: false,
    signed: false,
    duplicate: false,
    generating_next: false,
    teacher_list: [],
    proportions_type: "A"
  },
  teacherInfo: {
    id: "",
    name: "",
    rut: "",
    sign_date: "",
    contracts:""
  },

};



// WEBPACK FOOTER //
// ./src/reducers/initialState.js